module.exports = __webpack_public_path__ + "static/cluster-01671b22b9ff8b65a86314d515443e94.png";